var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"legend",attrs:{"id":_vm.legendId}}),_c('div',{ref:"chartReport",staticClass:"report-chart chartdiv float-left",attrs:{"id":_vm.chartId}})])}
var staticRenderFns = []

export { render, staticRenderFns }